// Auto generated file, do not manually modify!
// com.hotpads.capps.enums.PreferredLeaseLength

export enum PreferredLeaseLength {
  MONTH_TO_MONTH = 'MONTH_TO_MONTH',
  SIX_MONTHS = 'SIX_MONTHS',
  TWELVE_MONTHS = 'TWELVE_MONTHS',
  TWENTY_FOUR_MONTHS = 'TWENTY_FOUR_MONTHS',
}

export const PreferredLeaseLength_values = [
  PreferredLeaseLength.MONTH_TO_MONTH,
  PreferredLeaseLength.SIX_MONTHS,
  PreferredLeaseLength.TWELVE_MONTHS,
  PreferredLeaseLength.TWENTY_FOUR_MONTHS,
] as const;
